(function($, window){

    // On document ready
    $(function(){
        
        // Scroll effects
        {
            
            let header = $('#main-header');
            let shield = header.find('.shield');
            let footer = $('#site-footer');
            let hero = $('#hero');
            let overlayText = hero.find('.hero-overlay');
            let carouselNav = hero.find('.slide-nav');
            let timelineContainer = $('#timeline-container');
            let timelineExists = !!timelineContainer.length;
            let overlayExists = !!overlayText.length;
            let carouselNavExists = !!carouselNav.length;
            let heroExists = !!hero.length;

            let overlayOpacity = 1;
            let shieldOpacity = 0;
            let carouselNavOpacity = 1;
            let headerOpacity = 1;
            
            let cards;
            let windowHeight;
            let windowWidth;
            let timelineBuffer;

            if (timelineExists) {
                cards = timelineContainer.find('.developments > div');
                cards.each((i, el) => {
                    $(el).data('quickSetter', gsap.quickSetter(el, 'css'));
                });

                onTimelineResize();
                onTimelineScroll();
                window.addEventListener('scroll', throttle(onTimelineScroll, 16), false);
                window.addEventListener('resize', debounce(onTimelineResize, 500), false);
            }

            window.addEventListener('scroll', throttle(onScroll, 30), false);
            window.addEventListener('scroll', debounce(onScroll, 100), false);
            window.addEventListener('resize', debounce(onScroll, 100), false);

            function onTimelineScroll() {
                let windowBottomEdge = window.scrollY + windowHeight;
                
                cards.each(function(i, el){
                    let newOpacity = (windowBottomEdge - $(el).data('yOffset')) / timelineBuffer;
                    newOpacity = Power2.easeOut(gsap.utils.clamp(0, 1, newOpacity));
                    let card = $(el);
                    if (card.data('opacity') != newOpacity) {
                        let sign = windowWidth > 767 ? 2 * (i % 2) - 1 : 1;
                        card.data('quickSetter')({
                            opacity: newOpacity,
                            rotate: sign * 15 * (1 - newOpacity)
                        });
                        card.data('opacity', newOpacity);
                    }
                });
            }
            
            function onTimelineResize() {
                windowHeight = window.innerHeight;
                windowWidth = window.innerWidth;
                timelineBuffer = windowHeight / 2;
                cards.each((i, el) => {
                    $(el).data('yOffset', el.getBoundingClientRect().top + window.scrollY);
                });
                
                onTimelineScroll();
            }
        
            function onScroll() {

                let heroBounds, heroBottomEdge, newShieldOpacity, newCarouselNavOpacity;
                
                let headerBounds = header[0].getBoundingClientRect();
                let headerBottomEdge = headerBounds.bottom;
                let footerTopEdge = footer[0].getBoundingClientRect().top;
                let newHeaderOpacity = Math.min(1, Math.max(0, (footerTopEdge - headerBottomEdge) / 100));
    
                if (heroExists) {
                    heroBounds = hero[0].getBoundingClientRect();
                    heroBottomEdge = heroBounds.bottom;
                    newShieldOpacity = 1 - Math.min(1, Math.max(0, (heroBottomEdge - headerBottomEdge) / 200));
                    newCarouselNavOpacity = 1 - Math.min(1, Math.max(0, newShieldOpacity * 2));
                }
                else {
                    newShieldOpacity = 1;
                }

                if (overlayExists) {
                    let overlayBounds = overlayText[0].getBoundingClientRect();
                    let minBuffer = ((heroBounds.height - overlayBounds.height) / 2) - headerBounds.height;
                    let minBufferClamped = Math.min(100, Math.max(1, minBuffer * 0.8));
                    let overlayTopEdge = overlayBounds.top;
                    let newOverlayOpacity = Math.min(1, Math.max(0, (overlayTopEdge - headerBottomEdge) / minBufferClamped));

                    if (newOverlayOpacity != overlayOpacity) {
                        overlayOpacity = newOverlayOpacity;
                        overlayText[0].style.opacity = overlayOpacity;
                    }
                }
    
                if (newShieldOpacity != shieldOpacity) {
                    shieldOpacity = newShieldOpacity;
                    shield[0].style.opacity = shieldOpacity;
                }
    
                if (carouselNavExists && newCarouselNavOpacity != carouselNavOpacity) {
                    carouselNavOpacity = newCarouselNavOpacity;
                    carouselNav[0].style.opacity = carouselNavOpacity;
                }

                if (newHeaderOpacity != headerOpacity) {

                    // If there's been a switch from 0 to 1 or back 
                    if (!!newHeaderOpacity != !!headerOpacity) {
                        if (!newHeaderOpacity) {
                            header.addClass('hide');
                        }
                        else {
                            header.removeClass('hide');
                        }
                    }

                    headerOpacity = newHeaderOpacity;
                    header[0].style.opacity = headerOpacity;
                }
            }
    
            onScroll();
        }
        
    });

})(jQuery, window);
